import { hasPermission } from '@shared/auth';
import { contactTableFiltersSchema } from '@shared/types/contact-filters.type';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { useAuthContext } from '@web/auth';
import { router } from '@web/lib/react-router';
import { Navigate } from '@tanstack/react-router';

let activeCommentId: string | null = null;

const setActiveCommentId = (commentId: string | null) => {
  activeCommentId = commentId;
  void router.invalidate();
};

export const Route = createFileRoute('/dashboard/admin/contact')({
  component: View,
  beforeLoad: ({
    context: {
      auth: { user },
    },
  }) => {
    if (!user)
      throw redirect({
        to: '/auth/sign-in',
        search: { returnTo: location.pathname },
      });

    return {
      loggedInUser: user,
      activeCommentId,
      setActiveCommentId,
    };
  },
  validateSearch: zodSearchValidator(contactTableFiltersSchema),
});

function View() {
  const { user } = useAuthContext();

  if (!user) return null;

  if (!hasPermission(user, 'contacts_module', 'access')) {
    return <Navigate to="/dashboard" />;
  }
  return <Outlet />;
}
